import Vue from "vue";
import Router from "vue-router";

/* EXTRAS */
import Layout from '@/layout'
import Settings from "@/settings.js";
Vue.use(Router);

let DEFAULT_TITLE = "Cargando..."

//export default
export const router = new Router({
  base: process.env.VUE_APP_URL_BASE_PATH,
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'home',
      redirect: 'login'
    },
    {
      path: '/devices',
      component: Layout,
      meta: {
        title:  ' - Dispositivos',
        breadCrumb: 'Zonas',
        requiresAuth: true
      },
      children: [
        {
          path: 'edit/:id',
          name: "location-details",
          component: () => import('@/views/devices/DevicesList'),
          meta: {
            title:  ' - Editar zona',
            breadCrumb: 'Editar zona',
            guest: true
          }
        },
        {
          path: '',
          name: "show-location",
          component: () => import('@/views/devices/DevicesList'),
          meta: {
            title:  ' - Listado zonas',
            breadCrumb: 'Listado zonas',
            guest: true
          }
        },
        {
          path: 'add',
          name: "add-location",
          component: () => import('@/views/devices/DevicesList'),
          meta: {
            title:  ' - Agregar zonas',
            breadCrumb: 'Agregar zona'
          }
        },
        {
          path: 'locations',
          name: "devices-zones",
          component: () => import('@/views/devices/DevicesList'),
          meta: {
            title:   ' - Ubicaciones',
            breadCrumb: 'Ubicaciones',
            guest: true
          }
        },
        {
          path: 'nodes',
          name: 'devices-nodes',
          component: () => import('@/views/devices/NodeList'),
          meta: {
            title:  ' - Listado de nodos',
            breadCrumb: 'Listado de nodos',
            guest: false
          },
        },
        {
          path: 'nodes/config',
          name: 'devices-nodes-config',
          component: () => import('@/views/devices/DevicesConfig'),
          meta: {
            title:  ' - Configuracion nodos',
            breadCrumb: 'Config. de nodos',
            guest: true
          }
        },
        {
          path: 'sensors',
          name: "devices-sensors",
          component: () => import('@/views/devices/SensorList'),
          meta: {
            title:  ' - Sensores',
            breadCrumb: 'Listado de sensores',
            guest: true
          }
        },
        {
          path: 'groups',
          name: "devices-groups",
          component: () => import('@/views/groups/Groups'),
          meta: {
            title:  ' - Análisis avanzado',
            breadCrumb: 'Análisis avanzado',
            guest: true
          }
        },
        {
          path: '/superset-dashboard/embed',
          name: 'SupersetEmbed',
          component: () => import('@/views/SupersetEmbed.vue'), 
        },
      ]
    },

    {
      path: '/user',
      name: 'user',
      component: Layout,
      meta: {
        title:  ' - Users',
        breadCrumb: 'Usuario',
        guest: true
      },
      children: [
        {
          path: 'profile',
          name: 'profile',
          component: () => import('@/views/user/Profile'),
          meta: {
            title:  ' - Profile',
            breadCrumb: 'Mi cuenta',
            guest: true
          }
        },
        {
          path: 'messages',
          name: 'messages',
          component: () => import('@/views/user/Messages'),
          meta: {
            title:  ' - Messages',
            breadCrumb: 'Mensajes',
            guest: true
          }
        },
        {
          path: 'logout',
          name: 'logout',
          component: () => import('@/components/logout/Logout'),
          meta: {
            title:  ' - Logout ',
            guest: true
          }
        }
      ]
    },
    {
      path: '/filters',
      name: 'filters',
      component: Layout,
      meta: {
        title:  ' - Estado de los filtros',
        breadCrumb: 'Filtros',
        guest: true
      },
      children: [
        {
          path: 'status',
          name: 'filter-status',
          component: () => import('@/views/filters/Filters'),
          meta: {
            title:  ' - Estado de los filtros',
            breadCrumb: 'Filtros',
            guest: true
          }
        }
      ]
    },
    {
      path: '/notification',
      name: 'notification',
      component: Layout,
      meta: {
        title:  ' - Notificaciones',
        breadCrumb: 'Notificationes',
        guest: true
      },
      children: [
        {
          path: 'list',
          name: 'notification-list',
          component: () => import('@/views/notification/List'),
          meta: {
            title:  ' - Notificaciones',
            breadCrumb: 'Listado',
            guest: true
          }
        }
      ]
    },
    {
      path: '/dashboard',
      component: Layout,
      meta: {
        title:  ' - Dashboard',
        breadCrumb: 'Panel',
        requiresAuth: true
      },
      children: [
        {
          path: '',
          name: 'dashboard',
          component: () => import('@/views/dashboard/Dashboard')
        }
      ]
    },
    {
      path: '/admin',
      component: Layout,
      children: [
        {
          path: 'settings',
          name: 'settings',
          component: () => import('@/views/dashboard/SettingsList'),
          meta: {
            title:  ' - Ajustes',
            breadCrumb: 'Ajustes',
            requiresAuth: true,
            is_admin: true
          }
        },
        {
          path: 'users',
          name: 'users',
          component: () => import('@/views/dashboard/UsersList'),
          meta: {
            title:  ' - Usuarios',
            breadCrumb: 'Usuarios',
            requiresAuth: true,
            is_admin: true
          }
        },
        {
          path: 'roles',
          name: 'roles',
          component: () => import('@/views/dashboard/RolesList'),
          meta: {
            title:  ' - Roles',
            breadCrumb: 'Roles',
            requiresAuth: true,
            is_admin: true
          }
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/login/Login'),
      meta: {
        title:  ' - Sign in ',
        guest: true
      }
    },
    {
      path: '/statistics',
      component: Layout,
      meta: {
        title:  ' - Statistics',
        breadCrumb: 'Estadisticas',
        requiresAuth: true
      },
    },
    {
      path: '/reports',
      component: Layout,
      meta: {
        title:  ' - Reports',
        breadCrumb: 'Informes',
        requiresAuth: true
      },
    },
    {
      path: '/bitacora',
      component: Layout,
      children: [
        {
          path: '',
          name: 'bitacora',
          component: () => import('@/views/bitacora/Bitacora'),
          meta: {
            title:  ' - Bitacora',
            breadCrumb: 'Bitacora',
            requiresAuth: true
          }
        }
      ]
    },

  ]
});


// Router.beforeEach() for handling requests based on meta specifications:
router.beforeEach(async (to, from, next) => {
  //Change page title
  let titulo = await Settings
  document.title = titulo.title + to.meta.title || DEFAULT_TITLE;

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('jwt') == null) {
      //Token null
      next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      })
    } else {
      //Token no null
      let user = JSON.parse(localStorage.getItem('user'))
      if (to.matched.some(record => record.meta.isAdmin)) {
        /*TODO:
        * We are using status as an isAdmin flag. This should be changed in the future
        */
        if (user.status == 1) {
          next()
        }
        else {
          next({ name: 'devices' })
        }
      } else {
        next()
      }
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    //if(localStorage.getItem('jwt') == null){
    next()
    //}
    //else{
    //next({ name: 'show-fastdata'})
    //}
  } else {
    next()
  }
})


export default router;
